<div role="main">
  <h2 class="h2 font-semibold guts-m-t-1-half guts-m-b-quart guts-p-h-1-quart">
    {{ savedHeader }}
  </h2>
  <p class="par--light par--small guts-m-b-1-half guts-p-h-1-quart">
    {{ i18n.QueueCtrl_SavedDescription }}
  </p>
  <div *ngIf="saved.length">
    <dgx-lazy-chunk
      class="grid"
      [list]="saved"
      [trackBy]="trackSavedByID"
      [options]="{ threshold: 0.5 }"
      [loadingTemplateHeight]="29"
      [chunkSize]="6"
      [rowLength]="rowLength"
    >
      <ng-template let-context>
        <dgx-tile-launcher
          class="tile__wrapper"
          [item]="context.localItem.reference"
          [tileIndex]="context.itemIndex"
          [lazyChunkIndex]="context.lazyChunkIndex"
          [actionContext]="context.localItem"
          [expandCard]="
            contentCardService.shouldLazyLoadedCardExpand(
              context.itemIndex,
              context.lazyChunkIndex,
              null
            ) | async
          "
        >
        </dgx-tile-launcher>
      </ng-template>
    </dgx-lazy-chunk>
  </div>
  <!-- pageLoading skeleton -->
  <div *ngIf="pageLoading">
    <ul class="grid">
      <li
        *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8, 9]"
        [class.grid__col-lg-3]="rowLength === 4"
        [class.grid__col-lg-4]="rowLength === 3"
        class="grid__col-xs-6 grid__col-sm-4"
        data-dgat="profile-saved-780"
      >
        <div class="tile__wrapper">
          <dgx-skeleton type="tile" layout="random"></dgx-skeleton>
        </div>
      </li>
    </ul>
  </div>
</div>

<!-- No Saved Instructions -->
<div *ngIf="!saved.length" class="grid l_flex-justify-center">
  <dgx-profile-empty-state
    [title]="i18n.QueueCtrl_EmptyStateTitle"
    [description]="i18n.QueueCtrl_EmptyStateDescription"
    [helpText]="noItemsPlaceholder"
  ></dgx-profile-empty-state>
</div>
<div class="footer-glasses guts-m-t-8"></div>
